const isInRange = (
    value: number,
    minimumValue: number,
    maximumValue: number,
    postDecimals: number,
) => {
    const factor = Math.pow(10, postDecimals);
    const lowerBound = Math.floor(minimumValue * factor) / factor;
    const upperBound = Math.ceil(maximumValue * factor) / factor;

    // Meter overflow / rollover: when the minimum is greater than the maximum the
    // expected range wraps around the meter's overflow point. A value is plausible
    // when it is at or above the lower bound OR at or below the upper bound.
    if (lowerBound > upperBound) {
        return lowerBound <= value || upperBound >= value;
    }

    return lowerBound <= value && upperBound >= value;
};

const isBigger = (value: number, compareValue: number, postDecimals: number) => {
    const factor = Math.pow(10, postDecimals);
    return Math.floor(compareValue * factor) / factor <= value;
};

export { isInRange, isBigger };
